// extracted by mini-css-extract-plugin
module.exports = {"packingListContainer":"PackingList_packingListContainer__24Lj-","packingList":"PackingList_packingList__3-TPd","templateContent":"PackingList_templateContent__3DHtx"};